import React from 'react';

import Modal from '../../Modal';
import WrongIcon from '../../../images/donation/wrong.svg';
import { navigate } from '@reach/router';

const DonateToProjectFailedModal = ({ open, onClose, onConfirmDelete }) => {
  const handleContactUs = () => {
    onConfirmDelete();
    onClose();
    navigate('/contact');
  };

  return (
    <Modal open={open} onClose={onClose} sx={{ maxWidth: '900px' }}>
      <div className="project-deletion-modal">
        <div className="project-deletion-modal-container">
          <div className="donation-project-img">
            <img src={WrongIcon} />
          </div>
          <h2 className="donation-project-msg">Your donation has been failed</h2>
          <div className="donation-modal-body">
            <p className="donation-project-descriptions">
              We regret to inform you that your giving has failed to process. Please double-check your payment details
              and try again to support our cause. We apologize for any inconvenience. If you need further assistance,
              please don't hesitate to contact us.
            </p>

            <div className="btn-group donation-project-button">
              <button className="btn btn-md btn-primary-ii" onClick={handleContactUs}>
                Contact Us
              </button>
            </div>

            <div>
              <p style={{ textAlign: 'center', marginTop: '64px', color: '#656565' }}>
                © Lineage Journey {new Date().getFullYear()}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DonateToProjectFailedModal;
